export const environment = {
    serverUrl:"https://ahc.zenzo.in"
}
